import { ProtectedRoute } from '@appclose/core';

import verifySession from 'components/hoc/verifySession';

export default verifySession(ProtectedRoute);
